
<div class="modal-dialog confirm-dialog" style="display: flex; justify-content: center;">
  <div class="modal-content" style="min-width:630px;">
    <form #orderForm="ngForm">
      <div class="modal-body">
        <label>You have selected a Central to Central invoicing model. Please check that the Business Partner IDs you are adding during this onboarding are in accordance with the documents received from the customer and that you are selecting the applicable Deployment Country for the assets in this project. If they are not, please ask for correction to the initiator of the project.</label>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="cancel()">OK</button>
      </div>
    </form>
  </div>
</div>